// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import Popover from '@ta/overlays.popover';
import { showNativeOverflowMenu } from './NativeBridge';
import type { NativeOverflowMenu } from './NativeBridge';
import styles from './NativeOverflowUI.less';

type Props = {|
  className?: string,
  nativeMenu: ?NativeOverflowMenu,
|};

/**
 * NativeOverflowUI provides an button that looks like an ellipses (...) that, when activated, opens a
 * native menu
 */
const NativeOverflowUI = ({ className, nativeMenu }: Props) => (
  <div className={className || ''}>
    <Popover
      below
      alignEdge="right"
      shiftX={10}
      shiftArrow={10}
      arrowType="small"
      contents={() => null}
      closeButton={false}
      local
    >
      {target => (
        <div
          className={styles.icon}
          ref={target}
          onClick={() => nativeMenu && showNativeOverflowMenu(nativeMenu)}
        >
          <Icon name="more-horizontal" />
        </div>
      )}
    </Popover>
  </div>
);

NativeOverflowUI.defaultProps = {
  className: undefined,
  nativeMenu: undefined,
};

export default NativeOverflowUI;
